import { ComponentPropsWithoutRef, FC } from "react"
import { AccentButton } from "shared/components/buttons/AccentButton"
import { rotate } from "shared/styles/keyframes"
import styled from "styled-components"

const Loader = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${(props) => props.theme.button.bgColor};
  display: flex;
  align-items: center;
  justify-content: center;
`

const Spinner = styled.div`
  box-sizing: border-box;
  border-radius: 50%;
  border-color: ${(props) => props.theme.button.textColor};
  border-style: solid;
  border-width: 3px;
  border-left-color: transparent;
  height: ${(props) => props.theme.button.loaderSize};
  width: ${(props) => props.theme.button.loaderSize};
  animation: ${rotate} 1.2s infinite linear;
`

export type LoaderButtonProps = ComponentPropsWithoutRef<"button"> & {
  isLoading?: boolean
}

const LoaderButton: FC<LoaderButtonProps> = ({
  children,
  isLoading = false,
  onClick = () => {},
  type = "button",
  ...remainingProps
}) => (
  <AccentButton
    {...remainingProps}
    onClick={isLoading ? null : onClick}
    type={type}
  >
    {isLoading && (
      <Loader>
        <Spinner />
      </Loader>
    )}
    {children}
  </AccentButton>
)

export default LoaderButton
